/** @format */

import { type Ref } from 'react'
import type { CompoundFC } from '@/shared/lib/compound'

const cx = (...classes: (string | boolean | undefined | null)[]) =>
  classes.filter(Boolean).join(' ')

const GridContainer = ({ className, children, ref, ...rest }: any & { ref?: Ref<any> }) => (
  <div
    ref={ref}
    className={cx(
      'flex justify-center gap-20 w-full h-full overflow-y-auto',
      'max-[1720px]:[zoom:0.94]',
      'max-[1599px]:[zoom:0.86]',
      'max-[1439px]:[zoom:0.76]',
      'max-[1279px]:[zoom:0.66]',
      'max-[1119px]:[zoom:0.58]',
      'max-[1023px]:[zoom:1] max-[1023px]:flex-wrap max-[1023px]:gap-5',
      'max-[768px]:whitespace-normal max-[768px]:gap-4',
      className,
    )}
    {...rest}
  >
    {children}
  </div>
)
GridContainer.displayName = 'GridContainer'

const GridSection = ({ amount, className, children, ref, ...rest }: any & { ref?: Ref<any> }) => (
  <div ref={ref} className={cx('grid grid-cols-2 gap-0.75 h-fit', className)} {...rest}>
    {children}
  </div>
)
GridSection.displayName = 'GridSection'

const GridSection2 = ({ amount, className, children, ref, ...rest }: any & { ref?: Ref<any> }) => (
  <div ref={ref} className={cx('grid gap-0.75 grid-cols-[repeat(2,0.465fr)]', className)} {...rest}>
    {children}
  </div>
)
GridSection2.displayName = 'GridSection2'

const GridSection3 = ({ className, children, ref, ...rest }: any & { ref?: Ref<any> }) => (
  <div ref={ref} className={cx('grid gap-0.75 grid-cols-[repeat(4,0.465fr)]', className)} {...rest}>
    {children}
  </div>
)
GridSection3.displayName = 'GridSection3'

const GridSection4 = ({ className, children, ref, ...rest }: any & { ref?: Ref<any> }) => (
  <div ref={ref} className={cx('grid gap-0.75', className)} {...rest}>
    {children}
  </div>
)
GridSection4.displayName = 'GridSection4'

const CartCardWrapper: CompoundFC = ({
  className,
  children,
  ref,
  ...rest
}: any & { ref?: Ref<any> }) => (
  <div ref={ref} className={cx('grid gap-4.5 p-2.5 bg-white', className)} {...rest}>
    {children}
  </div>
)
CartCardWrapper.displayName = 'CartCardWrapper'

const CartCardTop = ({
  width,
  height,
  className,
  children,
  ref,
  ...rest
}: any & { ref?: Ref<any> }) => (
  <div
    ref={ref}
    className={cx(
      'grid items-end text-left w-(--icon-w) h-(--icon-h) [&_svg]:w-(--icon-w) [&_svg]:h-(--icon-h)',
      className,
    )}
    {...rest}
    style={{
      '--icon-w': width,
      '--icon-h': height,
    }}
  >
    {children}
  </div>
)
CartCardTop.displayName = 'CartCardTop'
CartCardWrapper.Top = CartCardTop

const CartCardFooter = ({ className, children, ref, ...rest }: any & { ref?: Ref<any> }) => (
  <div
    ref={ref}
    className={cx(
      'grid font-roboto font-normal text-left text-(--tertiary-font-color)',
      '[&_.title]:text-base [&_.description]:text-xs',
      className,
    )}
    {...rest}
  >
    {children}
  </div>
)
CartCardFooter.displayName = 'CartCardFooter'
CartCardWrapper.Footer = CartCardFooter

const HomeBottomContainer = ({ className, children, ref, ...rest }: any & { ref?: Ref<any> }) => (
  <div
    ref={ref}
    className={cx(
      'w-full flex gap-7.75 items-baseline',
      'max-[1200px]:gap-5.25',
      'max-[1024px]:gap-2.75',
      'max-[768px]:gap-px max-[768px]:flex-wrap',
      className,
    )}
    {...rest}
  >
    {children}
  </div>
)
HomeBottomContainer.displayName = 'HomeBottomContainer'

export {
  GridContainer,
  GridSection,
  GridSection2,
  GridSection3,
  GridSection4,
  CartCardWrapper,
  HomeBottomContainer,
}
